<template>
  <v-container fluid>
    <template>
      <v-card>
        <v-card-title>
          <h2>
            <v-btn class="mx-2" icon text small :to="{ name: 'sub-grupo-item-list'}">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span v-if="loading">Carregando...</span>
            <template v-else>
              <span v-if="tituloNovo">Novo sub-grupo de item</span>
              <span v-else>Alterar sub-grupo de item: {{descricao}}</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-card-text>
            <v-text-field
              v-model="codigo"
              :error-messages="codigoErrors"
              :counter="10"
              label="Código"
              required
              @input="$v.codigo.$touch()"
              @blur="$v.codigo.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="descricao"
              :error-messages="descricaoErrors"
              :counter="50"
              label="Descrição"
              required
              @input="$v.descricao.$touch()"
              @blur="$v.descricao.$touch()"
            ></v-text-field>
            <v-autocomplete
              v-model="select"
              :loading="loading"
              :items="items"
              item-text="descricao"
              item-value="id"
              :search-input.sync="search"
              cache-items
              hide-no-data
              label="Grupo de item"
              :error-messages="selectErrors"
              v-touch="select"
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-btn depressed color="primary" @click="submit" :loading="loading">Salvar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  validations: {
    codigo: { required, maxLength: maxLength(10) },
    descricao: { required, maxLength: maxLength(50) },
    select: { required }
  },

  data() {
    return {
      id: "",
      descricao: "",
      codigo: "",
      preloader: false,
      tituloNovo: true,

      loading: false,
      search: null,
      select: null
    };
  },

  computed: {
    descricaoErrors() {
      const errors = [];
      if (!this.$v.descricao.$dirty) return errors;
      !this.$v.descricao.maxLength && errors.push("Somente 50 caracteres");
      !this.$v.descricao.required && errors.push("Descrição é Obrigatório");
      return errors;
    },
    codigoErrors() {
      const errors = [];
      if (!this.$v.codigo.$dirty) return errors;
      !this.$v.codigo.maxLength && errors.push("Somente 10 caracteres.");
      !this.$v.codigo.required && errors.push("Código é obrigatório");
      return errors;
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      !this.$v.select.required && errors.push("Informe o grupo de item");
      return errors;
    },
    items() {
      return this.$store.state.subGrupoItem.grupoItem;
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    }
  },

  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        const success = await this.$store.dispatch("subGrupoItem/gravar", {
          id: this.id,
          descricao: this.descricao,
          codigo: this.codigo,
          id_grupoitem: this.select
        });
        this.loading = false;
        if (success) {
          this.$router.replace({ path: "lista", name: "sub-grupo-item-list" });
        }
      }
    },
    querySelections(v) {
      this.loading = true;
      v;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de sub-grupos de item"
    });
    this.loading = true;
    if (this.$route.params.id) {
      var id = this.$route.params.id;
      this.id = id;
      this.tituloNovo = false;

      try {
        var response = await this.$store.dispatch(
          "subGrupoItem/carregarSubGrupoItem",
          { id }
        );
        this.descricao = response.data.descricao;
        this.codigo = response.data.codigo;
        this.select = response.data.id_grupoitem;

        //this.preloader = false;
      } catch (err) {
        //deu pau
      }
    }

    // preencher combo grupo item
    try {
      await this.$store.dispatch("subGrupoItem/carregarGrupoItem");

      //this.preloader = false;
    } catch (err) {
      //deu pau
    }
    this.loading = false;
  }
};
</script>
